import {Component, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css'],
  animations: [
    trigger('showHide',[
      state('show', style({
        opacity: 1,
      })),
      state('hide', style({
        opacity: 0,
      })),
      transition('hide=>show', [
        animate('500ms'),
      ]),
      transition('show=>hide', [
        animate('10ms')
      ])

    ])
  ]
})
export class SpinnerComponent implements OnInit {

  @Input()
  loading: number;
  constructor() { }

  get spin(): boolean {
    return this.loading === 1;
  }
  ngOnInit() {
  }

}
